import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { CustomBreakPointsProvider } from "./custom-breakpoints";
import { HorizontalLayoutModule } from "./horizontal/horizontal-layout.module";
import { VerticalLayoutModule } from "./vertical/vertical-layout.module";


@NgModule({
  imports: [
    FlexLayoutModule.withConfig({ disableDefaultBps: true }),
    VerticalLayoutModule,
    HorizontalLayoutModule,
  ],
  providers: [CustomBreakPointsProvider],
  exports: [VerticalLayoutModule, HorizontalLayoutModule],
})
export class LayoutModule {}
